import { createContext } from "react";

export const NodeContext = createContext();
